import type { FC } from '../../../lib/teact/teact';
import React, {
  memo, useCallback, useMemo, useState, useRef, useEffect
} from '../../../lib/teact/teact';


import DropdownMenu from '../../ui/DropdownMenu';
import MenuItem from '../../ui/MenuItem';

import ConfirmDialog from '../../ui/ConfirmDialog';
import SearchInput from '../../ui/SearchInput';
import { LotScreenSettings } from '../config/uiconfig';
import Button from '../../ui/Button';
import buildClassName from '../../../util/buildClassName';

import { DBManager, deleteDatabase } from '../db/dbManager';
import KqxsDialog from '../ui/qkxsDialog';


import { callApi } from '../../../api/gramjs';
import { Api } from '../../../lib/gramjs';
import { MAIN_THREAD_ID, type ApiChat } from '../../../api/types';
import { getActions, getGlobal, setGlobal, withGlobal } from '../../../global';
import useForceUpdate from '../../../hooks/useForceUpdate';
import store from '../store';
import { updateLotteryActive } from '../redux/global';
import { selectChat } from '../../../global/selectors';
import { FetchAllChatAndSaveToLocal, FetchAllMessageAndSaveToLocal, FetchAllMessages } from '../tdlib/tdlib';
import { removeMessageFromStore } from '../redux/tdlibSlice';
import { DEBUG } from '../../../config';
import '../ui/formCommon.scss'
import { DownloadAllContactGiaThuong } from '../db/repository/contactRepo';
import Snackbar from '../ui/snackbar';
import { daiLyChinh, setDaiLyChinh } from '../globalSettings/globalVariable';
import { LoginApi } from '../restapi/loginApi';
import InstallPWAButton from '../globalSettings/InstallPWAButton';
import TelegramBotLink from '../ui/TelegramBotLink';
type FakeProps = {
  fake: "fake"
}
type OwnProps = {
  currentScreen: LotScreenSettings;
  editedFolderId?: number;
  onSearchQuery: (query: string) => void
  onReset: () => void;
  onChangeScreen: (screen: LotScreenSettings) => void;
  onMenuAction: (menuId: string) => void;

};

const LotMainHeader: FC<OwnProps> = ({
  currentScreen,
  editedFolderId,
  onReset,
  onSearchQuery,
  onChangeScreen,
  onMenuAction,

}) => {
  const { showNotification } = getActions()
  const globalStore = store;
  const mainToolbarRef = useRef<HTMLDivElement>()
  function handleToTelegram() {
    onReset()
    let global = getGlobal()
    global.lotteryActive = false

    setGlobal(global, { forceOnHeavyAnimation: true, forceSyncOnIOs: true, noUpdate: false })
    globalStore.dispatch(updateLotteryActive({ lotteryActive: false }))


  }
  function renderHeaderContent() {
    switch (currentScreen) {
      case LotScreenSettings.CONTACT_LIST_SCREEN:
        return (
          <div className="settings-main-header" style="display:flex;flex-direction:row;gap:0.5rem;">

            <div className="right-panel" style="flex: 1; gap: 0.25rem;">
              <SearchInput
                inputId="telegram-search-input"
                parentContainerClassName="LeftSearch"
                onChange={(e) => onSearchQuery(e)}
              >
              </SearchInput>
              <DropdownMenu positionX="right">
                <MenuItem
                  icon={store.getState().contact.filterContactByType == "AllContacts" ? "icon icon-check " : ""}
                  onClick={() => {
                    onMenuAction("AllContacts")
                  }}
                >
                  Toàn bộ danh bạ
                </MenuItem>
                <MenuItem
                  icon={store.getState().contact.filterContactByType == "CustomerContacts" ? "icon icon-check " : ""}
                  onClick={() => { onMenuAction("CustomerContacts") }}
                >
                  Danh sách khách
                </MenuItem>
                <MenuItem
                  icon={store.getState().contact.filterContactByType == "SupplierContacts" ? "icon icon-check " : ""}
                  onClick={() => { onMenuAction("SupplierContacts") }}
                >
                  Danh sách chủ
                </MenuItem>
              </DropdownMenu>
            </div>
          </div >
        );
      case LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN:
        return (<div className="settings-main-header" style="display:flex;flex-direction:row;">
          <Button
            round
            size="smaller"
            color="translucent"
            onClick={() => {
              onMenuAction("Parse:" + JSON.stringify(new Date()))
            }}

          >
            <i
              className={buildClassName('icon', 1 ? 'icon-smallscreen' : 'icon-fullscreen')}
              aria-hidden
            />
          </Button>
          <DropdownMenu positionX="right">
            <MenuItem onClick={() => {
              onMenuAction("ReadInbox" + JSON.stringify(new Date()))
            }}>
              Đọc tin đến
            </MenuItem>
            <MenuItem onClick={() => {
              onMenuAction("ReadOutbox" + JSON.stringify(new Date()))
            }}>
              Đọc tin đi
            </MenuItem>
            <MenuItem>
              Đặt tham số phân tích
            </MenuItem>
          </DropdownMenu>
        </div >
        )
      default:
        undefined;
    }
  }
  function handleLogout() {
    localStorage["access_token"] = ""
    //deleteDatabase();
    const protocol = window.location.protocol;
    const hostName = window.location.hostname;
    const currentURL = new URL(window.location.href);
    const port = currentURL.port;
    const portStr = port == '80' ? "" : ":" + port
    const newUrlStr = `${protocol}//${hostName}${portStr}`

    window.location.href = newUrlStr;
    onReset()
  }
  const [state, setState] = useState({
    confirmLogoutOpen: false,
    openKqxs: false,
    menuAction: "",
    snackbarOpen: false,
    snackbarMessage: "",
    duration: 3000,
    daiLyChinh: daiLyChinh,
  })
  function showSnackbar(message: string, duration: number = 3000) {
    setState({
      ...state,
      snackbarOpen: true,
      snackbarMessage: message,
      duration: duration,
    })
  }

  async function handleTestTeleFunc() {
    // store.dispatch(removeMessageFromStore({}))
    // //const result = await FetAllMessages(false)
    showSnackbar("Đang tải dữ liệu,vui lòng chờ đến khi có thông báo hoàn thành...", 10000)
    DownloadAllContactGiaThuong().then((res: any) => {
      showSnackbar(res.responseText)
    })
    //  const result = await FetchAllChatAndSaveToLocal()
    //  const messages = await FetchAllMessageAndSaveToLocal()

    // Kiểm tra xem trình duyệt có hỗ trợ Notification không
    if ('Notification' in window) {
      // Yêu cầu sự cho phép hiển thị thông báo
      Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
          // Hiển thị thông báo
          new Notification('Thông báo', {
            body: 'Đang tải số liệu. vui lòng chờ 30 giây.'
          });
        } else {
          console.log('Thông báo đã bị từ chối bởi người dùng.');
        }
      });
    } else {
      console.log('Trình duyệt không hỗ trợ thông báo.');
    }
  }
  useEffect(() => {
    if (mainToolbarRef) {
      if (mainToolbarRef.current) {
        mainToolbarRef.current.scrollIntoView()
        if (DEBUG)
          console.log("Main toolbar scrooled to")
      }
    }
  }, [])
  useEffect(() => {
    LoginApi.getNearestAgentContact().then(res => {
      if (res && res.data) {
        setState(prev => ({ ...prev, daiLyChinh: res.data.lienHe }))
        setDaiLyChinh(res.data.lienHe)
      }
    })

  }, [])
  return (
    <>
      <div id="LeftMainHeader"
        ref={mainToolbarRef}
        className={currentScreen == LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN ? "lot-left-header" : "left-header"}>
        <div style="position: absolute; top: -500px; left: -500px; right: 0; bottom: 0; width: 0; height: 0; overflow: hidden;">
          <Snackbar isOpen={state.snackbarOpen} message={state.snackbarMessage}
            triggerTime={new Date()}
            duration={state.duration}
            onClose={() => { setState((prev) => ({ ...prev, snackbarOpen: false })) }}></Snackbar>
          <ConfirmDialog
            title='Thoát BachKhoaSo'
            isOpen={state.confirmLogoutOpen}
            text="Bạn có chắc chắn đăng xuất và thoát?"
            onClose={() => { setState((prev) => ({ ...state, confirmLogoutOpen: false })) }}

            confirmLabel={'Thoát'}

            confirmHandler={() => { handleLogout() }}
            confirmIsDestructive

          />
          <KqxsDialog isOpen={state.openKqxs}
            onClose={() => {
              setState((prev) => {
                return {
                  ...prev,
                  openKqxs: false,

                }
              })
            }
            }
            onConfirm={() => {
              setState((prev) => {
                return {
                  ...prev,
                  openKqxs: false,

                }
              })
            }}
          />
        </div>
        <DropdownMenu >
          {true &&
            <MenuItem icon='icon icon-favorite-filled'
              onClick={() => { onChangeScreen(LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN) }}
            >
              Làm việc hàng ngày
            </MenuItem>
          }
          <MenuItem
            icon='user'
            onClick={() => { onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN) }}
          >
            Danh bạ
          </MenuItem>
          <MenuItem
            icon='icon icon-loop'
            onClick={() => { onChangeScreen(LotScreenSettings.TRON_SO_SCREEN) }}
          >
            Trộn số
          </MenuItem>
          <MenuItem
            icon='icon icon-folder'
            onClick={() => { onChangeScreen(LotScreenSettings.MAIN_REPORT_SCREEN) }}
          >
            Tổng hợp ngày, báo cáo
          </MenuItem>
          <MenuItem onClick={() => { setState((prev) => ({ ...state, openKqxs: true })) }}
            icon="icon icon-download">
            Tải KQXS
          </MenuItem>

          <MenuItem icon='settings'

            onClick={() => { onChangeScreen(LotScreenSettings.SETTING_SCREEN) }}
          >
            Cài đặt
          </MenuItem>
          <MenuItem icon='bots'

            onClick={() => { onChangeScreen(LotScreenSettings.BOT_SETTINGS_SCREEN) }}
          >
            Thiết lập telegram bot
          </MenuItem>
          <MenuItem onClick={handleToTelegram} icon="icon icon-arrow-left">
            Telegram
          </MenuItem>
          <MenuItem onClick={() => { onChangeScreen(LotScreenSettings.ADMIN_SCREEN) }}
            icon="icon icon-key">
            Quản lý tài khoản cấp dưới
          </MenuItem>
          <MenuItem onClick={() => { setState((prev) => ({ ...state, confirmLogoutOpen: true })) }} icon="icon icon-logout">
            Đăng xuất LotteryVn
          </MenuItem>
          <MenuItem >
            Hạn sử dụng: {localStorage["expireDate"]}
          </MenuItem>
          <MenuItem
            onClick={handleTestTeleFunc}
          >
            Đồng bộ dữ liệu, phục vụ lưu trữ cục bộ
          </MenuItem>
          <MenuItem
            onClick={() => {
              window.open(state.daiLyChinh, '_blank')
            }}
          >
            <div>
              <a href={state.daiLyChinh}> CSKH :{state.daiLyChinh}</a>
            </div>

          </MenuItem>
          <MenuItem>
            <TelegramBotLink username="bachkhoaAIbot" />
          </MenuItem>
          <MenuItem>
            <InstallPWAButton />
          </MenuItem>
        </DropdownMenu>



        <div className='right-panel'>
          {renderHeaderContent()}
        </div>

      </div>
    </>
  );
};

// export default memo(withGlobal((global): FakeProps => {
//     return {
//       fake:"fake"
//     }
// }))
//  (LotMainHeader)
export default memo(LotMainHeader)